<!--Title Section-->
<br>
<app-title-jumbo title="Support" comment="Feel free to contact us to get the appropriate answers to your question"></app-title-jumbo>

<!--Support Section-->
<div class="my-container">
  <div class="container">
    <div class="offset-1 col-10">

      <!--Carousel Wrapper-->
      <div id="carousel-support" class="carousel slide carousel-fade" data-ride="carousel">

        <!--Slides-->
        <div class="carousel-inner" role="listbox">
          <!-- First slide -->
          <div class="carousel-item active">
            <!--Mask color-->
            <div class="view">
              <!--Video source-->
              <video class="video-fluid" autoplay loop muted>
                <source src="assets/img/animation.mp4" type="video/mp4" />
              </video>
              <div class="mask rgba-blue-dark"></div>
            </div>
          </div>
          <!-- /.First slide -->
        </div>
        <!--/.Slides-->

        <!--Bottom information-->
        <div class="row mt-3">
          <div class="col-8" style="height:300px">
            <!--Descriptions-->
            <div class="carousel-description-0 h-100">
              <div class="col h-100">
                <app-title header="Support" title="Help Desk" priority="3"></app-title>

                To provide all customers with information and support related to our products and services.
                Our team is happy to troubleshoot problems or provide guidance. Various channels such as
                toll-free numbers, websites, instant messaging, or email are available.

                <br /><br />
                <div class="row">
                  <div class="col-10">
                        <span class="float-right">
                          <app-line-button green>Contact us</app-line-button>
                        </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--Controls-->
          <div class="col pl-4" style="height:300px; border-left: 1px solid #aaa">
            <a class="blue-link" (click)="goToHelpDesk()"><h5>Help Desk</h5></a>
            <em style="font-size: 0.8em;">To provide you with information and support related to our products and services.</em>
            <br /><br />
            <a class="blue-link" (click)="goToCallUs()"><h5>Call us</h5></a>
            <em style="font-size: 0.8em;">0033 1424 24242 <br /> Monday to Friday - 8:00am to 7:00pm</em>
            <br /><br />
            <a class="blue-link" (click)="goToMessage()"><h5>Message</h5></a>
            <em style="font-size: 0.8em;">Our team makes every effort to answer your emails in less than 24 hours.</em>
          </div>
        </div>
        <!--Bottom information-->

      </div>
      <!--/.Carousel Wrapper-->

      <br />
      <!--Section: Contact v.2-->
      <section class="mb-4">

        <!--Section description-->
        <p class="text-center w-responsive mx-auto mb-5 grey-text">Should you have any questions, do not hesitate to contact us directly. Our team will come back to you within a matter of hours to help you.</p>

        <div class="row">

          <!--Grid column-->
          <div class="col-md-9 mb-md-0 mb-5">
            <form id="contact-form" name="contact-form" action="mail.php" method="POST">

              <!--Grid row-->
              <div class="row">

                <!--Grid column-->
                <div class="col-md-6">
                  <div class="md-form mb-0">
                    <input type="text" id="name" name="name" class="form-control">
                    <label for="name" class="card-text">Your name</label>
                  </div>
                </div>
                <!--Grid column-->

                <!--Grid column-->
                <div class="col-md-6">
                  <div class="md-form mb-0">
                    <input type="text" id="email" name="email" class="form-control">
                    <label for="email" class="card-text">Your email</label>
                  </div>
                </div>
                <!--Grid column-->

              </div>
              <!--Grid row-->

              <!--Grid row-->
              <div class="row">
                <div class="col-md-12">
                  <div class="md-form mb-0">
                    <input type="text" id="subject" name="subject" class="form-control">
                    <label for="subject" class="card-text">Subject</label>
                  </div>
                </div>
              </div>
              <!--Grid row-->

              <!--Grid row-->
              <div class="row">

                <!--Grid column-->
                <div class="col-md-12">

                  <div class="md-form">
                    <textarea type="text" id="message" name="message" rows="2" class="form-control md-textarea"></textarea>
                    <label for="message">Your message</label>
                  </div>

                </div>
              </div>
              <!--Grid row-->

            </form>

            <div class="text-center text-md-center">
              <app-button onclick="document.getElementById('contact-form').submit();">Send</app-button>
            </div>
            <div class="status"></div>
          </div>
          <!--Grid column-->

          <!--Grid column-->
          <div class="col-md-3 text-center mt-3">
            <ul class="list-unstyled mb-0">
              <li><i class="fas fa-map-marker-alt fa-2x"></i>
                <p>75004 Paris, France</p>
              </li>

              <li><i class="fas fa-phone mt-5 fa-2x"></i>
                <p>0033 1 234 567 89</p>
              </li>

              <li><i class="fas fa-envelope mt-5 fa-2x"></i>
                <p>contact@factor-based-investing.com</p>
              </li>
            </ul>
          </div>
          <!--Grid column-->

        </div>

      </section>
      <!--Section: Contact v.2-->

      <br><br>
    </div>
  </div>
</div>
<!--Support Section-->

<!-- Footer -->
<footer class="page-footer">

  <!-- Copyright -->
  <div class="text-center">
    <p style="color: slategrey">© 2020 Copyright: <strong>www.factor-based-investing.com</strong></p>
  </div>
  <!-- Copyright -->

</footer>
<!-- Footer -->
